import SEOOptimized from '@/components/SEOOptimized';
import PremiumLayout from '@/components/premium/PremiumLayout';
import HeroCinematic from '@/components/cinematic/HeroCinematic';
import TrustStrip from '@/components/cinematic/TrustStrip';
import RepairShowcase from '@/components/cinematic/RepairShowcase';
import ProductsShowcase from '@/components/cinematic/ProductsShowcase';
import RecentSales from '@/components/cinematic/RecentSales';
import HowItWorks from '@/components/cinematic/HowItWorks';
import CTAClosing from '@/components/cinematic/CTAClosing';
import StaticReviews from '@/components/StaticReviews';
import WhyBuyFromUs from '@/components/cinematic/WhyBuyFromUs';
import FreeTools from '@/components/cinematic/FreeTools';
import ExplodedPC from '@/components/exploded/ExplodedPC';
import LaptopSection from '@/components/exploded/LaptopSection';
import { lazy, Suspense } from 'react';
import SafeSection from '@/components/SafeSection';

// Below-the-fold extras live in their own small chunks (speed fix 2026-10-10:
// together they had grown the first-load file by ~12 KB gz and slowed the
// first paint on slow phones by ~0.1 s). The downloads start as soon as the
// app runs — after the page is already on screen — so they are ready long
// before anyone scrolls to them. The fallbacks reserve roughly their height.
const loadEstimator = () => import('@/components/PriceEstimator');
const loadMap = () => import('@/components/cinematic/ServiceAreaMap');
const loadBeforeAfter = () => import('@/components/cinematic/BeforeAfter');
const PriceEstimator = lazy(loadEstimator);
const ServiceAreaMap = lazy(loadMap);
const BeforeAfter = lazy(loadBeforeAfter);
if (typeof window !== 'undefined') {
  loadEstimator();
  loadMap();
  loadBeforeAfter();
}

export default function PremiumIndex() {
  // useCinReveal + useCinMagnetic are mounted globally in PremiumLayout.
  // Homepage is B2C-focused (private clients). B2B / Sevev lives at /business/.
  // The business entity (JSON-LD) comes from SEOOptimized, once per page.

  return (
    <>
      <SEOOptimized
        title="תיקון מחשבים בגולן | בנה מחשבים - BenaPC, נטור"
        description="תיקון מחשבים בגולן: ייעוץ חינם לפני שמוציאים כסף, מחיר בכתב לפני שמתחילים, 3 חודשי אחריות. מעבדה בנטור, בתיאום מראש. 054-667-2863"
      />
      <PremiumLayout>
        <HeroCinematic />
        <TrustStrip />
        {/* 2026-10-27 (owner): computer sales are the heart of the business — real
            sold computers, with price, first name and town, right under the hero. */}
        <RecentSales from="home" />
        {/* 2026-10-20 (owner-approved): how it works and the Google reviews come
            before the scroll scenes — on a phone the page is ~24 screens, and
            many visitors never scroll past the exploded PC. */}
        <HowItWorks />
        <section className="bg-white py-[clamp(48px,8vw,104px)] px-[clamp(20px,5vw,80px)]">
          <div className="mx-auto max-w-[1280px]">
            <StaticReviews />
          </div>
        </section>
        <ExplodedPC />
        <FreeTools />
        <SafeSection>
        <Suspense fallback={<div className="min-h-[760px] md:min-h-[620px] bg-white" />}>
          <PriceEstimator />
        </Suspense>
        </SafeSection>
        <RepairShowcase />
        {/* Buying through the lab, right after repairs (owner, 2026-10-10: make it prominent). */}
        <ProductsShowcase />
        <LaptopSection />
        <SafeSection>
        <Suspense fallback={null}>
          <BeforeAfter />
        </Suspense>
        </SafeSection>
        <SafeSection>
        <Suspense fallback={<div className="min-h-[980px] lg:min-h-[640px] bg-[#0B1224]" />}>
          <ServiceAreaMap />
        </Suspense>
        </SafeSection>
        <WhyBuyFromUs />
        <CTAClosing />
      </PremiumLayout>
    </>
  );
}
